import { DigitalOrderStatuses } from '@/shared/api/digitalOrder';
import { type SchemaDigitalOrder, type SchemaDigitalOrderStatus } from '@/shared/api/openApi';
import { type OrderDto, type OrderStatus, OrderStatuses } from '@/shared/api/order';

const EditableOrderStatuses = new Set<OrderStatus | SchemaDigitalOrderStatus>([
    OrderStatuses.NEW,
    OrderStatuses.PENDING_PAYMENT,
    DigitalOrderStatuses.NEW,
    DigitalOrderStatuses.PENDING_PAYMENT,
]);

export const isOrderEditable = (order?: OrderDto | SchemaDigitalOrder) =>
    order?.status ? EditableOrderStatuses.has(order.status) : false;
